import { SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.scss";
interface ILogoCompProps {
  sx?: SxProps<Theme>;
}
export const DarkLogo = (props: ILogoCompProps) => {
  return (
    <Box
      className={styles.logo_img}
      component="img"
      src="/assets/images/svg/waffyLogo.svg"
      sx={props.sx}
    />
  );
};
export const WhiteLogo = (props: ILogoCompProps) => {
  return (
    <Box
      component="img"
      className={styles.logo_img}
      src="/assets/images/svg/whiteWaffyLogo.svg"
      sx={props.sx}
    />
  );
};
